module.exports = __webpack_public_path__ + "static/media/manoharan.48adc4f7.png";